import { AttemptTrigger } from '../../../../typings/EventAttempt.interface';

export const ATTEMPT_TRIGGER_LABELS: Record<AttemptTrigger, string> = {
  AUTOMATIC: 'Automatic Retry',
  MANUAL: 'Manual Retry',
  BULK_RETRY: 'Bulk Retry',
  INITIAL: 'Initial',
  UNPAUSE: 'Unpause',
};
